// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"9a7e914b","990":"6d815313"}[chunkId] + ".chunk.css";
};